// extracted by mini-css-extract-plugin
module.exports = {"right-arrow":"SliderArrows_right-arrow__16J81"};